// Sidebar entries owned by the Dayoffs module. The shell places them: see
// src/app/nav.tsx and src/modules/README.md.
import { resources, scopes } from '@vnetwork/datacentral-core/auth'
import { dayoffsPaths } from './paths'

// The sidebar fields Dayoffs' entries use. Structurally the app's SidebarType
// (src/types/shared): src/app/nav.tsx places these entries, so a drift between
// the two fails typecheck there.
interface DayoffsNavItem {
    title: string
    path: string
    rsname?: string
    require_scopes?: string[]
    visible_permission_denied?: boolean
}

export const dayoffsNav = {
    manage: {
        title: 'dayoffs:sidebar_title',
        path: dayoffsPaths.dayOffsManage,
        rsname: resources.dayoff,
        require_scopes: [scopes.index],
        visible_permission_denied: false,
    },
    account: {
        title: 'day-off-account',
        path: dayoffsPaths.dayOffAccountList,
    },
} satisfies Record<string, DayoffsNavItem>
